import { useContext } from "react";

// Third party
import { jsPDF } from "jspdf";

//internal
import { GlobalContextData } from "../../../context";
import "./SharedTopHeader.scss";
import { Button } from "../../Button";

export const SharedTopHeader = () => {
  const { dispatch, state } = useContext(GlobalContextData);

  const downloadDoc = () => {
    dispatch({
      type: "SET_LOADING",
      payload: { isLoading: true, loadingText: "Downloading..." },
    });
    try {
      const input = document.getElementById("editor-container");
      const temp = input?.getElementsByClassName("editor")[0];
      // @ts-ignore
      const width = temp?.offsetWidth;
      // @ts-ignore
      const height = temp?.offsetHeight;

      const doc = new jsPDF({
        orientation: "p",
        format: [width, height],
        unit: "pt",
      });

      // Adding the fonts
      doc.setFont("Inter-Regular", "normal");

      doc.html(temp as HTMLElement, {
        async callback(doc) {
          await doc.save(`${state.documentInfo.name}.pdf`);
          dispatch({
            type: "SET_LOADING",
            payload: { isLoading: false, loadingText: "" },
          });
        },
      });
    } catch (err) {
      console.error("Download failed", err);
      dispatch({
        type: "SET_LOADING",
        payload: { isLoading: false, loadingText: "" },
      });
    }
  };
  return (
    <div className="shared-top-header-container ">
      <div className="left-shared-section"></div>
      <div className="center-shared-section">
        <img src={"/Logo.jpg"} alt=" Logo" height={60} />
        <div className="doc-with-status">
          <span className="doc-name">{state.documentInfo.name || ""}</span>
        </div>
        <Button
          className="download-button"
          size="small"
          variant="outlined"
          onClick={downloadDoc}
        >
          Download
        </Button>
      </div>
      <div className="right-shared-section"></div>
    </div>
  );
};
